import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-manage-measurement-units-dialog-list-item',
  templateUrl: './manage-measurement-units-dialog-list-item.component.html',
  styleUrls: ['./manage-measurement-units-dialog-list-item.component.scss']
})
export class ManageMeasurementUnitsDialogListItemComponent implements OnInit {

  @Input() item: any;
  @Input() opened = false;
  @Input() shallNotOpen = false;

  constructor() { }

  ngOnInit(): void {
  }

}
